var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCheck(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.5231 14.0351C21.5231 18.1911 18.154 21.5602 13.998 21.5602C9.84202 21.5602 6.47292 18.1911 6.47292 14.0351C6.47292 9.87913 9.84202 6.51003 13.998 6.51003C18.154 6.51003 21.5231 9.87913 21.5231 14.0351Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M25.5365 13.995L23.0883 11.2057L23.4294 7.51338L19.8074 6.69064L17.9111 3.5L14.4997 4.96488L11.0883 3.5L9.19199 6.69064L5.56991 7.50335L5.91105 11.1957L3.46289 13.995L5.91105 16.7843L5.56991 20.4866L9.19199 21.3094L11.0883 24.5L14.4997 23.0251L17.9111 24.49L19.8074 21.2993L23.4294 20.4766L23.0883 16.7843L25.5365 13.995ZM12.493 19.0117L8.47961 14.9983L9.89433 13.5836L12.493 16.1722L19.105 9.5602L20.5198 10.9849L12.493 19.0117Z",
    fill: "#998F43"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheck);
export default __webpack_public_path__ + "static/media/check.55ab1881f0802822cfdb7c50442971f3.svg";
export { ForwardRef as ReactComponent };